import React, { useState, useEffect } from "react";
import EncabezadoVistaCcUo from "./EncabezadoVistaCvUo";
import MensajeVistaCcUo from "./MensajeVistaCcUo";
import TablePagination from "@mui/material/TablePagination";
import {
  IconEditCircle,
  IconSearch,
  IconEye,
  IconCircleX,
  IconCircleCheck,
  IconEdit,
} from "@tabler/icons";
import {
  Typography,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  TextField,
  Modal,
  TableCell,
  TableContainer,
  TableBody,
  Table,
  TableHead,
  TableRow,
  Select,
  MenuItem,
} from "@material-ui/core";
import Loading from "../../utilidades/Loading";
import {
  obtenerBusquedaContrato,
  obtenerOperaciones,
  obtenerGerenciaGeneral,
  obtenerGerencia,
  obtenerArea,
  obtenerSuperIntendencia,
  obtenerCentroCosto,
  obtenerOperacion_ModalUsuarioContrato,
  obtenerlistadoCentrosDeCosto,
  insertarDatosDuenaContrato,
  insertarDatosUsuariaContrato,
} from "../../actions/vista_cc_uo";
import { obtenerMantenedorUnOrganizacional } from "../../actions/MantenedorUnOrganizacional";
import { obtenerOperacion } from "../../actions/MantenedorOperacion";
import jsonPrueba from "./unidadOrganizacionalActualizacion.json";
import "./EstilosVistaCcUo.css";
import Autocomplete from "@mui/material/Autocomplete";
import Checkboxmui from "@mui/material/Checkbox";
import TextFieldmui from "@mui/material/TextField";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const TablaVistaCcUo = () => {
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [campoBuscar, setCampoBuscar] = useState([]);
  const [errorcampoBuscar, setErrorCampoBuscar] = useState("");
  const [leyendacampoBuscar, setLeyendaCampoBuscar] = useState("");
  const [modalDuenaContrato, setModalDuenaContrato] = useState(false);
  const [modalUsuariaContrato, setModalUsuariaContrato] = useState(false);
  const [almacenarDatos, setAlmacenarDatos] = useState([]);
  const [apiChecked, setApiChecked] = useState([]);

  const [guardarPost, setGuardarPost] = useState([]);

  const [habilitarCheckBox, sethabilitarCheckBox] = useState(null);
  const [objetoMatriz, setObjetoMatriz] = useState({
    id: "",
    operacion: "",
    gerenciageneral: "",
    gerencia: "",
    area: "",
    superintendencia: "",
    estado: "",
    centrocosto: "",
    centrocostonombre: "",
  });
  // Almacenes response Endpoints x select
  const [almacenOperaciones, setAlmacenOperaciones] = useState([]);
  const [almacenGerenciaGeneral, setAlmacenGerenciaGeneral] = useState([]);
  const [almacenGerencia, setAlmacenGerencia] = useState([]);
  const [almacenArea, setAlmacenArea] = useState([]);
  const [almacenSuperIntendencia, setAlmacenSuperIntendencia] = useState([]);
  const [almacenCentroCosto, setAlmacenCentroCosto] = useState([]);
  const [almacenOperacionesDos, setAlmacenOperacionesDos] = useState([]);
  const [datosCompletos, setDatosCompletos] = useState([]);
  const [almacenCheckBoxCeCo, setAlmacenCheckBoxCeCo] = useState([]);
  const [guardarDatos, setGuardarDatos] = useState([]);
  const [miAlmacen, setMiAlmacen] = useState([]);
  const [guardarOperacion, setGuardarOperacion] = useState([]);
  const [modalExito, setModalExito] = useState(false);
  const [modalError, setModalError] = useState(false);

  // Objetos Insert
  const [unidadOrganizacionalContrato, setUnidadOrganizacionalContrato] =
    useState({
      idContrato: 0,
      idUnidadOrganizacional: 0,
    });

  // Objetos Prueba
  const [dataOperaciones, setDataOperaciones] = useState([]);
  const [dataPrueba, setDataPrueba] = useState([]);
  const [dataPrueba2, setDataPrueba2] = useState([]);
  const [dataTemp, setDataTemp] = useState([]);
  const [dataOperacion, setDataOperacion] = useState([]);
  const [dataGerenciaGeneral, setDataGerenciaGeneral] = useState([]);
  const [dataGerencia, setDataGerencia] = useState([]);
  const [dataSuperIntendencia, setDataSuperIntendencia] = useState([]);
  const [dataArea, setDataArea] = useState([]);
  const [dataCentroCostoNombre, setDataCentroCostoNombre] = useState([]);
  // Data Seleccionada
  const [selectOperacion, setSelectOperacion] = useState("");
  const [selectGerenciaGeneral, setSelectGerenciaGeneral] = useState("");
  const [selectGerencia, setSelectGerencia] = useState("");
  const [selectSuperIntendencia, setSelectSuperIntendencia] = useState("");
  const [selectArea, setSelectArea] = useState("");
  const [selectCentroCosto, setSelectCentroCosto] = useState("");
  const [centroCostoSeleccionado, setCentroCostoSeleccionado] = useState(0);
  const [loading, setLoading] = useState(false);

  const capturarDatosSelect = (e) => {
    const { name, value } = e.target;
    setObjetoMatriz((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setMiAlmacen(e.target.value);
  };

  const habilitarOperaciones = async () => {
    await obtenerOperaciones()
      .then((response) => {
        setAlmacenOperaciones(response.data);
      })
      .catch((error) => {
        console.log("Error en la peticion :", error);
      });
  };

  const obtenerOperacionModalUsuarioContrato = async () => {
    await obtenerOperacion_ModalUsuarioContrato()
      .then((response) => {
        setAlmacenOperacionesDos(response.data);
      })
      .catch((error) => console.log("ERROR NIVEL 5", error));
  };

  const botonBuscarNumeroContrato = (e) => {
    let valorBuscado = e.target.value;
    setCampoBuscar(valorBuscado);
  };

  // METODO GET
  const getDatosPrueba = async () => {
    const data = await obtenerMantenedorUnOrganizacional();
    setDataPrueba2(data.data);
    setDataTemp(data.data);
  };

  const getOperaciones = async () => {
    const data = await obtenerOperacion();
    setDataOperaciones(data);
  };

  // VARIABLE PARA REPETIDOS
  var hash = {};

  const logicaBase = (unidades = dataPrueba) => {
    const JsonPrueba = unidades;

    let Operaciones = JsonPrueba.filter((o) =>
      hash[o.operacion] ? false : (hash[o.operacion] = true)
    );
    setDataOperacion(Operaciones);
    hash = {};

    let GerenciaGeneral = JsonPrueba.filter((o) =>
      hash[o.gerenciageneral] ? false : (hash[o.gerenciageneral] = true)
    );
    setDataGerenciaGeneral(GerenciaGeneral);
    hash = {};

    let Gerencia = JsonPrueba.filter((o) =>
      hash[o.gerencia] ? false : (hash[o.gerencia] = true)
    );
    setDataGerencia(Gerencia);
    hash = {};

    let SuperIntendencia = JsonPrueba.filter((o) =>
      hash[o.superintendencia] ? false : (hash[o.superintendencia] = true)
    );
    setDataSuperIntendencia(SuperIntendencia);
    hash = {};

    let Area = JsonPrueba.filter((o) =>
      hash[o.area] ? false : (hash[o.area] = true)
    );
    setDataArea(Area);
    hash = {};

    let CentroCosto = JsonPrueba.filter((o) =>
      hash[o.centrocosto] ? false : (hash[o.centrocosto] = true)
    );
    setDataCentroCostoNombre(CentroCosto);
    hash = {};
  };

  // PROCESO FILTRADO
  const filtrarFilas = (evt, fila) => {
    // OBJETO CON TODOS LOS LADOS
    const JsonPrueba = dataPrueba;

    // IDENTIFICAR EL FILTRO CORRESPONDIENTE
    switch (fila) {
      case "Operacion":
        setSelectOperacion(evt.target.value);
        let Operacion = JsonPrueba.filter(
          (x) => x.operacion == evt.target.value
        );
        setDataPrueba(Operacion);
        hash = {};
        logicaBase(Operacion);

        break;
      case "GerenciaGeneral":
        setSelectGerenciaGeneral(evt.target.value);
        let GerenciaGeneral = JsonPrueba.filter(
          (x) => x.gerenciageneral == evt.target.value
        );
        setDataPrueba(GerenciaGeneral);
        hash = {};
        logicaBase(GerenciaGeneral);

        break;
      case "Gerencia":
        setSelectGerencia(evt.target.value);
        let Gerencia = JsonPrueba.filter((x) => x.gerencia == evt.target.value);
        setDataPrueba(Gerencia);
        hash = {};
        logicaBase(Gerencia);

        break;
      case "Superintendencia":
        setSelectSuperIntendencia(evt.target.value);
        let Superintendencia = JsonPrueba.filter(
          (x) => x.superintendencia == evt.target.value
        );
        setDataPrueba(Superintendencia);
        hash = {};
        logicaBase(Superintendencia);

        break;
      case "Area":
        setSelectArea(evt.target.value);
        let Area = JsonPrueba.filter((x) => x.area == evt.target.value);
        setDataPrueba(Area);
        hash = {};
        logicaBase(Area);

        break;
      case "CentroCostoNombre":
        setSelectCentroCosto(evt.target.value);

        let autoLlenado = dataCentroCostoNombre.find(
          (x) => x.centrocosto == evt.target.value
        );

        setSelectOperacion(autoLlenado.operacion);
        setSelectGerenciaGeneral(autoLlenado.gerenciageneral);
        setSelectGerencia(autoLlenado.gerencia);
        setSelectSuperIntendencia(autoLlenado.superintendencia);
        setSelectArea(autoLlenado.area);
        setSelectCentroCosto(autoLlenado.centrocosto);

        let id = dataCentroCostoNombre.find(
          (x) => x.centrocosto == evt.target.value
        ).id;

        setCentroCostoSeleccionado(id);
        let CentroCostoNombre = JsonPrueba.filter(
          (x) => x.centrocosto == evt.target.value
        );
        setDataPrueba(CentroCostoNombre);
        hash = {};
        logicaBase(CentroCostoNombre);

        break;
    }
  };

  const getDatosContrato = async () => {
    await obtenerBusquedaContrato(campoBuscar)
      .then((response) => {
        let miOperacion =
          response.data.detalleCentroCosto != null
            ? response.data.detalleCentroCosto.operacion
            : null;
        let miId =
          response.data.detalleCentroCosto != null
            ? response.data.detalleCentroCosto.id
            : null;
        setGuardarOperacion(miOperacion);
        setAlmacenarDatos([response.data]);
        setErrorCampoBuscar("Contrato valido");

        // logica base y filtros

        const datos = dataPrueba2;

        let datosFiltrados = [];

        datos.forEach((element) => {
          if (element.estado == true) {
            datosFiltrados.push(element);
          } else if (element.id == miId) {
            datosFiltrados.push(element);
          } else {
          }
        });

        setDataPrueba(datosFiltrados);
        setDataTemp(datosFiltrados);
      })
      .catch((error) => {
        setErrorCampoBuscar("Contrato Inválido");
      });
  };

  // METODO POST
  const postModalDuenaContrato = async () => {
    let id = almacenarDatos[0].id;
    let idcentrocosto = centroCostoSeleccionado;

    const payload = {
      idContrato: id,
      idUnidadOrganizacional: idcentrocosto,
    };

    /* let dataCompleta = almacenarDatos
    let datosRecopilados = datosCompletos
    let idContrato = dataCompleta[0].detalleCentroCosto.id
    let idUnidadOrganizacional = datosRecopilados */

    await insertarDatosDuenaContrato(payload)
      .then((response) => {
        getDatosContrato();
        abrirModalExito();

      })
      .catch((error) => {
        console.log(error);
      });
  };

  const postModalUsuariaContrato = async () => {
    let dataCompleta = almacenarDatos;
    let datosRecopilados = datosCompletos;
    //let idcontratoEnvio = dataCompleta[0].detalleCentroCosto.id
    //let idcentrocostoEnvio = datosRecopilados
    let checked = apiChecked;
    /* let dataPost = {
      "contratoCentroCosto": [
        {
          "idcontrato": idcontratoEnvio,
          "idcentrocosto": idcentrocostoEnvio
        }
      ]
    }
 */
    let id = almacenarDatos[0].id;

    let contratoCentroCosto = [];

    if (checked.length > 0) {
      checked.forEach((element) => {
        contratoCentroCosto.push({
          idcontrato: id,
          idcentrocosto: parseInt(element),
        });
      });
    } else {
      contratoCentroCosto.push({ idcontrato: id, idcentrocosto: 0 });
    }

    let dataPost = { contratoCentroCosto: contratoCentroCosto };

    await insertarDatosUsuariaContrato(dataPost)
      .then((response) => {
        setGuardarPost(response.data);
        getDatosContrato();
        listadoCheckboxCentrosdeCosto();
        abrirModalExito();
      })
      .catch((error) => {
        abrirModalError();
      });
  };

  const listadoCheckboxCentrosdeCosto = async () => {
    let bd = almacenarDatos;

    let idcontrato = bd[0].id;
    let idOperacion = bd[0].idOperacion;
    await obtenerlistadoCentrosDeCosto(idcontrato, idOperacion)
      .then((response) => {
        let data = response.data.result;
        let objetoFiltrado = [];

        data.forEach((element) => {
          if (element.estado == true) {
            objetoFiltrado.push(element);
          } else if (element.estado == false && element.existe == true) {
            objetoFiltrado.push(element);
          } else {
          }
        });

        setAlmacenCheckBoxCeCo(objetoFiltrado);
        setGuardarDatos(objetoFiltrado);
      })
      .catch((error) => console.log("Error llamado CHECKBOX", error));
  };

  const capturarDatosLevantarModalDuenaContrato = () => {
    abrirModalDuenaContrato();
    logicaBase();
  };

  const capturarDatosLevantarModalUsuariaContrato = (event, arreglo) => {
    console.log("RECIBO EL ARREGLO: ", arreglo);
    abrirModalUsuariaContrato();
    listadoCheckboxCentrosdeCosto();
    habilitarCheckBoxCeCo();
  };

  const abrirModalDuenaContrato = async () => {
    limpiarCajas();
    setModalDuenaContrato(!modalDuenaContrato);
    setLoading(true);
    await getDatosPrueba();
    await getDatosContrato();

    if (almacenarDatos[0].detalleCentroCosto != null) {
      setSelectOperacion(almacenarDatos[0].detalleCentroCosto.operacion);
      setSelectGerenciaGeneral(
        almacenarDatos[0].detalleCentroCosto.gerenciageneral
      );
      setSelectGerencia(almacenarDatos[0].detalleCentroCosto.gerencia);
      setSelectSuperIntendencia(
        almacenarDatos[0].detalleCentroCosto.superintendencia
      );
      setSelectArea(almacenarDatos[0].detalleCentroCosto.area);
      setSelectCentroCosto(almacenarDatos[0].detalleCentroCosto.centrocosto);
      setCentroCostoSeleccionado(almacenarDatos[0].detalleCentroCosto.id);
    }

    setLoading(false);
  };

  const abrirModalUsuariaContrato = () => {
    setModalUsuariaContrato(!modalUsuariaContrato);
    const idOperacion = almacenarDatos[0].idOperacion;
    const data = dataOperaciones.data;
    setGuardarOperacion(data.find((x) => x.id == idOperacion).descripcion);
    //apiChecked
    if (almacenarDatos[0].centroCostoUsuario != "") {
      let centrosUsuario = almacenarDatos[0].centroCostoUsuario;
      let checks = [];
      centrosUsuario.forEach((element) => {
        checks.push(element.id.toString());
      });
      setApiChecked(checks);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const habilitarCheckBoxCeCo = () => {
    let valoresComparacion = almacenCheckBoxCeCo;
  };

  const limpiarCajas = () => {
    setSelectOperacion("");
    setSelectGerenciaGeneral("");
    setSelectGerencia("");
    setSelectSuperIntendencia("");
    setSelectArea("");
    setSelectCentroCosto("");
    setCentroCostoSeleccionado(0);

    getDatosPrueba();

    logicaBase(dataTemp);
  };

  const bodyModalExito = (
    <div className="act_modal_editar">
      <div className="act_modal_caja_Xcerrar">
        <IconCircleX
          size={33}
          color="#666666"
          stroke={2}
          style={{ marginRight: "5px", cursor: "pointer" }}
          onClick={() => abrirModalExito()}
        />
      </div>
      <div className="act_modal_caja_edit">
        <div className="act_modal_titulos">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IconCircleCheck
              size={85}
              color="#ABCC66"
              stroke={2}
              style={{ marginBottom: "25px" }}
            />
            <Typography>Datos Guardados con éxito</Typography>
          </div>
        </div>
        <div align="center">
          <br />
          <Button
            id="btn-confirm-aceptar"
            style={{ backgroundColor: "#2B5368", color: "white" }}
            color="secondary"
            onClick={() => abrirModalExito()}
          >
            ACEPTAR
          </Button>{" "}
        </div>
      </div>
    </div>
  );

  const bodyModalError = (
    <div className="modalEstilosExito">
      <IconCircleX
        size={65}
        backgroundColor="white"
        color="#bb2124"
        stroke={2}
        style={{ cursor: "pointer", marginBottom: "10px" }}
      //onClick={() => abrirModalCrear()}
      />
      <p>Error, favor revisar los datos</p>
    </div>
  );

  const abrirModalExito = () => {
    setModalExito(!modalExito);
  };

  const abrirModalError = () => {
    setModalError(!modalError);
  };

  useEffect(() => {
    habilitarOperaciones();
    obtenerOperacionModalUsuarioContrato();
    getDatosPrueba();
    getOperaciones();
  }, []);

  const contenidoDuenaContrato = (
    <section className="contenedor-modal-contenidoDuenaContrato">
      <div className="circle_close">
        <IconCircleX
          size={33}
          backgroundColor="white"
          color="#999999"
          stroke={2}
          style={{ cursor: "pointer" }}
          onClick={() => abrirModalDuenaContrato()}
        />
      </div>
      <div className="bold_textos_naranjos_modal">
        <IconEdit
          size={23}
          color="#F77F00"
          stroke={2}
          style={{ marginRight: 5 }}
        />
        Unidad Dueña del Contrato
      </div>
      {loading == true && <span className="loading-message">Cargando...</span>}
      <InputLabel>Operación</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        className="select-modal-duena-contrato"
        variant="outlined"
        label="Asset"
        name="operacion"
        defaultValue="Seleccione una Operacion"
        value={selectOperacion}
        onChange={(e) => filtrarFilas(e, "Operacion")}
      >
        {Object.values(dataOperacion).map((item) => (
          <MenuItem key={item.id} value={item.operacion}>
            {item.operacion}
          </MenuItem>
        ))}
      </Select>

      <InputLabel>Gerencia general</InputLabel>
      <Select
        //disabled={estadoNivelGerenciaGeneral}
        name="gerenciageneral"
        className="select-modal-duena-contrato"
        variant="outlined"
        labelId="demo-simple-select-label"
        label="Nivel 1"
        defaultValue="Seleccione una gerenciageneral"
        value={selectGerenciaGeneral}
        onChange={(e) => filtrarFilas(e, "GerenciaGeneral")}
      >
        {Object.values(dataGerenciaGeneral).map((item) => (
          <MenuItem key={item.id} value={item.gerenciageneral}>
            {item.gerenciageneral}
          </MenuItem>
        ))}
      </Select>

      <InputLabel>Gerencia</InputLabel>
      <Select
        //disabled={estadoNivelGerencia}
        name="gerencia"
        className="select-modal-duena-contrato"
        variant="outlined"
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        label="Nivel 2"
        defaultValue="Seleccione una Gerencia"
        value={selectGerencia}
        onChange={(e) => filtrarFilas(e, "Gerencia")}
      >
        {Object.values(dataGerencia).map((item) => (
          <MenuItem key={item.id} value={item.gerencia}>
            {item.gerencia}
          </MenuItem>
        ))}
      </Select>

      <InputLabel>Superintendencia</InputLabel>
      <Select
        //disabled={setEstadoNivelSuperIntendencia}
        name="superintendencia"
        className="select-modal-duena-contrato"
        variant="outlined"
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        label="Nivel 3"
        defaultValue="Seleccione una Superintendencia"
        value={selectSuperIntendencia}
        onChange={(e) => filtrarFilas(e, "Superintendencia")}
      >
        {Object.values(dataSuperIntendencia).map((item) => (
          <MenuItem key={item.id} value={item.superintendencia}>
            {item.superintendencia}
          </MenuItem>
        ))}
      </Select>

      <InputLabel>Area</InputLabel>
      <Select
        //disabled={estadoNivelArea}
        name="area"
        className="select-modal-duena-contrato"
        variant="outlined"
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        label="Nivel 4"
        defaultValue="Seleccione un Area"
        value={selectArea}
        onChange={(e) => filtrarFilas(e, "Area")}
      >
        {Object.values(dataArea).map((item) => (
          <MenuItem key={item.id} value={item.area}>
            {item.area}
          </MenuItem>
        ))}
      </Select>

      <InputLabel>Centro de costo</InputLabel>
      <Select
        //disabled={estadoNivelCentroCosto}
        name="centrocosto"
        className="select-modal-duena-contrato"
        variant="outlined"
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        label="Nivel 5"
        defaultValue="Seleccione un Centro Costo"
        value={selectCentroCosto}
        onChange={(e) => filtrarFilas(e, "CentroCostoNombre")}
      >
        {Object.values(dataCentroCostoNombre).map((item) => (
          <MenuItem key={item.id} value={item.centrocosto}>
            {item.centrocosto} - {item.centrocostonombre}
          </MenuItem>
        ))}
      </Select>

      <div className="btn_modal_crear_zona--versiondos">
        <Button
          id="btn_validar_datos"
          style={{ marginRight: "4px" }}
          className="estilos-boton-cancelar"
          variant="contained"
          onClick={() => abrirModalDuenaContrato()}
        >
          <IconCircleX
            size={25}
            color="white"
            stroke={2}
            style={{ marginRight: 4 }}
          />
          Cancelar
        </Button>
        <Button
          id="btn_validar_datos"
          className="estilos-boton-cancelar"
          variant="contained"
          onClick={() => limpiarCajas()}
        >
          <IconCircleX
            size={25}
            color="white"
            stroke={2}
            style={{ marginRight: 4 }}
          />
          Limpiar
        </Button>

        <div className="btn_modal_crear_zona--versiondos--boton-guardar">
          <Button
            id="btn_validar_datos"
            style={{ width: "100%" }}
            className="estilos-boton-guardar"
            variant="contained"
            onClick={() => postModalDuenaContrato()}
          >
            <IconCircleCheck
              size={25}
              color="white"
              stroke={2}
              style={{ marginRight: 4 }}
            />
            Guardar
          </Button>
        </div>
      </div>
    </section>
  );

  const contenidoUsuariaContrato = (
    <section className="contenedor-modal-contenidoUsuariaContrato">
      <div className="circle_close">
        <IconCircleX
          size={33}
          backgroundColor="white"
          color="#999999"
          stroke={2}
          style={{ cursor: "pointer" }}
          onClick={() => abrirModalUsuariaContrato()}
        />
      </div>
      <div className="bold_textos_naranjos_modal">
        <IconEdit
          size={23}
          color="#F77F00"
          stroke={2}
          style={{ marginRight: 5 }}
        />
        Unidad Usuaria del Contrato
      </div>

      <InputLabel id="label-asset" className="estilo-titulo-select">
        Operación : {guardarOperacion}
      </InputLabel>
      <InputLabel id="label-asset" className="estilo-titulo-select">
        Tipos centros de costos
      </InputLabel>

      <Autocomplete
        data-testid="autocomplete-centros-costo"
        className="zona-autocomplete ceco-autocomplete"
        multiple
        disableCloseOnSelect
        options={almacenCheckBoxCeCo}
        getOptionKey={(option) => option.id}
        value={almacenCheckBoxCeCo.filter((ceco) =>
          apiChecked.includes(String(ceco.id))
        )}
        onChange={(event, newValue) => {
          const ids = newValue.map((v) => String(v.id));
          setApiChecked(ids);
        }}
        getOptionLabel={(option) =>
          `${option.centrocosto} - ${option.centrocostonombre}`
        }
        filterOptions={(options, { inputValue }) => {

          const searchTerm = inputValue.toLowerCase().trim();

          if (!searchTerm) {
            return options;
          }

          const filtered = options.filter((option) => {
            const codigo = option.centrocosto?.toLowerCase() || '';
            const nombre = option.centrocostonombre?.toLowerCase() || '';

            const match = codigo.includes(searchTerm) || nombre.includes(searchTerm);


            return match;
          });

          return filtered;
        }}
        renderOption={(props, option, { selected }) => (
          <li
            {...props}
            className={`ceco-option ${selected ? "selected" : ""}`}
          >
            <Checkboxmui checked={selected} className="ceco-checkbox" />
            {option.centrocosto} - {option.centrocostonombre}
          </li>
        )}
        renderInput={(params) => (
          <TextFieldmui
            {...params}
            placeholder="Seleccione..."
            inputProps={{
              ...params.inputProps,
              "data-testid": "autocomplete-input",
            }}
          />
        )}
        componentsProps={{
          popupIndicator: {
            title: undefined
          }
        }}
      />


      <div className="btn_modal_crear_zona_2">
        <Button
          id="btn_validar_datos"
          className="estilos-boton-guardar"
          variant="contained"
          onClick={() => postModalUsuariaContrato()}
        >
          <IconCircleCheck
            size={25}
            color="white"
            stroke={2}
            style={{ marginRight: 4 }}
          />
          Guardar
        </Button>

        <Button
          id="btn_validar_datos"
          className="estilos-boton-cancelar"
          variant="contained"
          onClick={() => abrirModalUsuariaContrato()}
        >
          <IconCircleX
            size={25}
            color="white"
            stroke={2}
            style={{ marginRight: 4 }}
          />
          Cancelar
        </Button>
      </div>
    </section>
  );


  return (
    <div className="contenido_tabla_vista_cc">
      <EncabezadoVistaCcUo />
      <MensajeVistaCcUo />

      <div className="box-btn-crear-admin">
        <div className="box-btn-crear-admin-fila">
          {/* CAMPO DE BUSQUEDA DE CONTRATO */}
          <input
            className="campo-busqueda-contrato"
            id="outlined-basic"
            label="N° Contrato"
            placeholder="Ingrese un N° Contrato"
            helperText={leyendacampoBuscar}
            onChange={botonBuscarNumeroContrato}
          />
          <Button
            className="boton-campo-busqueda-contrato"
            variant="contained"
            onClick={getDatosContrato}
          >
            <IconSearch
              size={18}
              color="white"
              stroke={2}
              style={{ marginRight: "5px" }}
            />
            Buscar
          </Button>
        </div>

        <spam className="box-btn-crear-admin-fila-mensaje">
          {errorcampoBuscar}
        </spam>
      </div>

      <TableContainer>
        <Table className="estilosTabla1">
          <TableHead className="estilosTabla3">
            <TableRow className="estilosTabla4">
              <TableCell>
                <p
                  style={{
                    color: "white",
                    fontSize: ".9rem",
                    textAlign: "center",
                  }}
                >
                  N° Contrato
                </p>
              </TableCell>
              <TableCell>
                <p
                  style={{
                    color: "white",
                    fontSize: ".9rem",
                    textAlign: "center",
                  }}
                >
                  Nombre
                </p>
              </TableCell>
              <TableCell>
                <p
                  style={{
                    color: "white",
                    fontSize: ".9rem",
                    textAlign: "center",
                  }}
                >
                  Operación
                </p>
              </TableCell>
              <TableCell>
                <p
                  style={{
                    color: "white",
                    fontSize: ".9rem",
                    textAlign: "center",
                  }}
                >
                  Empresa <br />
                  contratista
                </p>
              </TableCell>
              <TableCell>
                <p
                  style={{
                    color: "white",
                    fontSize: ".9rem",
                    textAlign: "center",
                  }}
                >
                  Unidad dueña <br />
                  del contrato
                </p>
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                <p
                  style={{
                    color: "white",
                    fontSize: ".9rem",
                    textAlign: "center",
                  }}
                >
                  Unidad usuaria <br />
                  del contrato
                </p>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {Object.values(almacenarDatos).map((contrato) => {
              return (
                <TableRow key={contrato.id}>
                  <TableCell style={{ textAlign: "center" }}>
                    {contrato.nrcontrato}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {contrato.nombre}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {contrato.operacion}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {contrato.nombreEmpresa}
                  </TableCell>
                  <TableCell>
                    <div className="box-boton_cc_uo_editar">
                      <button
                        className="boton_cc_uo_editar"
                        onClick={() =>
                          capturarDatosLevantarModalDuenaContrato(
                            almacenarDatos
                          )
                        }
                      >
                        <IconEye
                          size={20}
                          color="black"
                          stroke={2}
                          style={{ marginRight: "5px" }}
                        />
                        Ver dueño
                      </button>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="box-boton_cc_uo_editar">
                      <button
                        className="boton_cc_uo_editar"
                        onClick={(event) =>
                          capturarDatosLevantarModalUsuariaContrato(
                            event,
                            almacenCheckBoxCeCo
                          )
                        }
                      >
                        <IconEye
                          size={20}
                          color="black"
                          stroke={2}
                          style={{ marginRight: "5px" }}
                        />
                        Ver usuario
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 15]}
          component="div"
          count={almacenarDatos.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      <Modal
        open={modalDuenaContrato}
      //onClose={abrirModalDuenaContrato}
      >
        {contenidoDuenaContrato}
      </Modal>

      <Modal open={modalUsuariaContrato} onClose={abrirModalUsuariaContrato}>
        {contenidoUsuariaContrato}
      </Modal>

      <Modal open={modalExito} onClose={abrirModalExito}>
        {bodyModalExito}
      </Modal>
    </div>
  );
};

export default TablaVistaCcUo;
